<po-page-list #poPageListComponent
  p-title="Recebimento Romaneio - Lista"
  [p-breadcrumb]="breadcrumb"
  [p-filter]="filterSettings"
>
  <div class="po-row">
    <po-button class="po-md-3" p-kind="secondary" p-label="Novo Romaneio NF" (p-click)="novoRomaneioNF()" > </po-button>
  </div>
  <po-table class="po-sm-12 po-md-12 po-lg-12"
    [p-height]="600"
    [p-hide-select-all]="true"
    [p-sort]="true"
    [p-striped]="true"
    [p-columns]="tabelaPrincipalColunas"
    [p-items]="tabelaPrincipalItens"
    [p-actions]="tabelaPrincipalActions"
    [p-actions-right]="false"
    p-spacing="small"
    [p-filter-type]="poSearchFilterMode"
    p-hide-table-search="false"
  ></po-table>

</po-page-list>

<po-modal #advancedFilterModal p-title="Filtros" [p-primary-action]="advancedFilterPrimaryAction">
  <form #f="ngForm">
    <po-datepicker
      class="po-md-6"
      name="DZ00DATA_DE"
      [(ngModel)]="tabelaPrincipalFiltro.dados.DZ00DATA_DE"
      p-format="dd/mm/yyyy"
      [p-iso-format]="formatExtended"
      p-label="Data de:"
    ></po-datepicker>
    <po-datepicker
      class="po-md-6"
      name="DZ00DATA_ATE"
      [(ngModel)]="tabelaPrincipalFiltro.dados.DZ00DATA_ATE"
      p-format="dd/mm/yyyy"
      [p-iso-format]="formatExtended"
      p-label="Data até:"
    ></po-datepicker>
    <po-input
      class="po-md-6"
      name="CZ00COD"
      [(ngModel)]="tabelaPrincipalFiltro.dados.CZ00COD"
      p-label="Código Romaneio"
      [p-maxlength]="6"
    ></po-input>
    <po-input
      class="po-md-6"
      name="CZ00ORIGEM"
      [(ngModel)]="tabelaPrincipalFiltro.dados.CZ00ORIGEM"
      p-label="Origem"
      [p-maxlength]="2"
    ></po-input>
    <po-select
      class="po-md-6"
      name="CSTATUS"
      p-label="Status"
      [(ngModel)]="tabelaPrincipalFiltro.dados.CSTATUS"
      [p-options]="[
        { label: 'Todos', value: '' },
        { label: 'Pendente Recebimento', value: 'PR' },
        { label: 'Recebido Totalmente', value: 'RT' },
      ]"
    >
    </po-select>
  </form>
</po-modal>

